export default {
    methods: {
        parsePotentiallyGroupedFloat(stringValue) {
            if (!stringValue || typeof stringValue === 'number') {
                return stringValue;
            }
            stringValue = stringValue.trim();
            let result = stringValue.replace(/[^0-9]/g, '');
            if (/[,.]\d{2}$/.test(stringValue)) {
                result = result.replace(/(\d{2})$/, '.$1');
            }
            return parseFloat(result);
        },

        addCurrency(value, selectedCurrency) {
            if (value !== undefined && selectedCurrency !== null) {
                let parsedValue = value;
                if (typeof value === 'string') {
                    parsedValue = this.parsePotentiallyGroupedFloat(value);
                }

                return `${this.$n(parsedValue, {
                    style: 'currency',
                    currency: selectedCurrency
                })}`;
            }
        },
    }
};
